import {makeStyles} from "@material-ui/core";

const withStyles = makeStyles(theme => ({
    root: {
        maxHeight: '288px',
        '& td': {
            padding: '6px'
        }
    },
}));

export default withStyles;